import { render, staticRenderFns } from "./WagonSuperstructure.vue?vue&type=template&id=8f6a621a&scoped=true"
import script from "./WagonSuperstructure.vue?vue&type=script&lang=js"
export * from "./WagonSuperstructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a621a",
  null
  
)

export default component.exports